import React from "react"
import XLSX from "xlsx";
import Dropzone from 'react-dropzone'

/* generate an array of column objects */
const make_cols = refstr => {
    let o = [], C = XLSX.utils.decode_range(refstr).e.c + 1;
    for(var i = 0; i < C; ++i) o[i] = {name:XLSX.utils.encode_col(i), key:i}
    return o;
};

/* list of supported file types */
const SheetJSFT = [
    "xlsx","xls"
].map(function(x) { return "." + x; }).join(",");



/*
  Simple HTML5 file input wrapper
  usage: <DataInput handleFile={callback} />
    handleFile(file:File):void;
*/
export class DataInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            fileName: props.fileName
        }
    };

    componentWillReceiveProps(props) {
        this.setState({
            fileName: props.fileName
        })
    }

    handleFile(file/*:File*/) {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, {type:rABS ? 'binary' : 'array'});
            if (this.props.bulkImport) {
                const data = wb.SheetNames.map((sheetName,index) => {
                    const sheet = wb.Sheets[sheetName]
                    return {
                        rows: XLSX.utils.sheet_to_json(sheet, {header: 1}),
                        name: sheetName,
                        index,
                        woodInfo: {
                            woodNr: sheet["N1"] ? sheet["N1"].w : undefined,
                            woodMoisture: sheet["N2"] ? sheet["N2"].w : undefined,
                            woodDensity: sheet["N3"] ? sheet["N3"].w : undefined,
                            roomTemperature: sheet["N4"] ? sheet["N4"].w : undefined,
                            roomMoisture: sheet["N5"] ? sheet["N5"].w : undefined,
                            insertionDirection: sheet["N6"] ? sheet["N6"].w : undefined,
                        }
                    }
                })

                data.forEach(sheet => {
                    sheet.articleNumber = sheet.rows[0][0]
                })

                this.props.onImportSuccess(data, file.name)
            }
            else {
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws, {header:1});

                this.props.onImportSuccess(data, file.name)
            }
        };
        if(rABS) reader.readAsBinaryString(file); else reader.readAsArrayBuffer(file);
    };

    handleChange(e) {
        const files = e.target.files;
        if(files && files[0]) {
            this.handleFile(files[0]);
        }
    };

    onDrop = (acceptedFiles, rejectedFiles) => {
        const file = acceptedFiles[0]

        if(file) {
            this.setState({
                fileName: file.name
            })
            this.handleFile(file)
        }
    }

    render() {
        const { t } = this.props  
        return (
        <form className="form-inline">
            <div className="form-group">
                <Dropzone onDrop={this.onDrop} multiple={false} accept={SheetJSFT}>
                    {({getRootProps, getInputProps, isDragActive}) => {
                        return (
                            <div
                                {...getRootProps()}
                                style={{width: "150px", border: "1px solid black", borderRadius: "5px", height: "150px", display: "flex", justifyContent: "center", alignItems: "center"}}
                            >
                                <input {...getInputProps()} />
                                <div style={{textAlign: "center", maxWidth: "130px"}}>
                                    {
                                        this.state.fileName ? <div><i className="far fa-file-excel fa-3x"/> <p style={{marginTop: "10px", wordBreak: "break-all"}}>{this.state.fileName}</p></div> : t('general.select_or_drop_file_here')
                                    }

                                </div>
                            </div>
                        )
                    }}
                </Dropzone>
            </div>
        </form>
    ); };
}